export const PATHS = {
  HOME: '/',
  CART: '/',
  CHECKOUT: '/checkout',
  BILLING: '/checkout#billing',
  REVIEW: '/checkout#review',
}

export const ID_ME_CALLBACK_URL = `${PATHS.CART}#access_token`
